import React, { FunctionComponent } from 'react';
import { Box } from '@wix/design-system';
import { LoaderIcon } from './LoaderIcon';
import css from './index.module.scss';

type LoaderProps = {
  isLoading: boolean;
};

export const Loader: FunctionComponent<LoaderProps> = ({ isLoading }) => (
  <Box
    className={`${css.wrapper} ${isLoading ? css.active : null}`}
    align="center"
    verticalAlign="middle"
  >
    <LoaderIcon />
  </Box>
);
